import React, { useState } from "react";
import "./offerNow.css"; // add your CSS

const OfferNow = () => {
  const [hovered, setHovered] = useState(null);

  const banners = [
    { id: 1, src: "assets/images/banner/3_1.jpg" },
    { id: 2, src: "assets/images/banner/3_2.jpg" },
    { id: 3, src: "assets/images/banner/3_3.jpg" },
  ];

  return (
    <div className="hiraola-banner_area">
      <div className="container-fluid">
        <div className="row">
          {banners.map((banner) => (
            <div key={banner.id} className="col-lg-4 col-md-6">
              <div
                className={`banner-item img-hover_effect ${
                  hovered === banner.id ? "hovered" : ""
                }`}
                onMouseEnter={() => setHovered(banner.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <a href="shop-left-sidebar.html">
                  <img
                    className="img-full"
                    src={banner.src}
                    alt="Hiraola's Banner"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfferNow;
